import { useState } from "react";
import { CorporateNumberInfo } from "../../../features/api-interfaces";
import { formatYearDate } from "../../../utils/format";
import {
  Input,
  Header,
  Button,
  FormField,
  SpaceBetween,
  Container,
  ColumnLayout,
  Form,
  Box,
  Badge,
} from "@cloudscape-design/components-themed";
import { COMMON_LABELS } from "../../default-constants";
import { LABELS, PLACE_HOLDERS } from "./constants";
import {
  isNull,
  isLengthValid,
  isKatakanaValid,
  isHalfNumberValid,
} from "../../../utils/inputValidation";
import { getMessage } from "../../../features/error/messages";

// 法人番号の入力チェック
export const checkCorporateNumber = (target: string, paramSetErrorMsg: any) => {
  const setErrorMsg = paramSetErrorMsg;
  // 必須
  if (isNull(target)) {
    setErrorMsg(getMessage("KGRERR055").label);
    return false;
  }
  // 文字長
  if (!isLengthValid(target, 13)) {
    setErrorMsg(getMessage("KGRERR059", 13).label);
    return false;
  }
  // 半角数値
  if (!isHalfNumberValid(target)) {
    setErrorMsg(getMessage("KGRERR006").label);
    return false;
  }
  setErrorMsg("");
  return true;
};

// 事業者名の入力チェック
export const checkCompanyName = (target: string, paramSetErrorMsg: any) => {
  const setErrorMsg = paramSetErrorMsg;
  // 必須
  if (isNull(target)) {
    setErrorMsg(getMessage("KGRERR055").label);
    return false;
  }
  // 文字長
  if (!isLengthValid(target, 30)) {
    setErrorMsg(getMessage("KGRERR058", 30).label);
    return false;
  }
  setErrorMsg("");
  return true;
};

// 事業者名カナの入力チェック
export const checkCompanyNameKana = (target: string, paramSetErrorMsg: any) => {
  const setErrorMsg = paramSetErrorMsg;
  // 必須
  if (isNull(target)) {
    setErrorMsg(getMessage("KGRERR055").label);
    return false;
  }
  // 文字長
  if (!isLengthValid(target, 45)) {
    setErrorMsg(getMessage("KGRERR058", 45).label);
    return false;
  }
  // カタカナ
  if (!isKatakanaValid(target)) {
    setErrorMsg(getMessage("KGRERR026").label);
    return false;
  }
  setErrorMsg("");
  return true;
};

// 登録時のチェック用に値とset関数を共通化
// 法人番号
let registerCheckCorporateNumber = "";
const setRegisterCheckCorporateNumber = (value: string) => {
  registerCheckCorporateNumber = value;
};
export let registerCheckCorporateNumberErrorMsg = "";
const setRegisterCheckCorporateNumberErrorMsg = (value: any) => {
  registerCheckCorporateNumberErrorMsg = value;
};
// 事業者名称
let registerCheckCompanyName = "";
const setRegisterCheckCompanyName = (value: string) => {
  registerCheckCompanyName = value;
};
let registerCheckCompanyNameErrorMsg = "";
const setRegisterCheckCompanyNameErrorMsg = (value: any) => {
  registerCheckCompanyNameErrorMsg = value;
};
// 事業者名称カナ
let registerCheckCompanyNameKana = "";
const setRegisterCheckCompanyNameKana = (value: string) => {
  registerCheckCompanyNameKana = value;
};
let registerCheckCompanyNameKanaErrorMsg = "";
const setRegisterCheckCompanyNameKanaErrorMsg = (value: any) => {
  registerCheckCompanyNameKanaErrorMsg = value;
};

// 法人番号情報
export let registerCorporateData = {
  corporateNumber: "",
  companyName: "",
  companyNameKana: "",
} as CorporateNumberInfo;
const setRegisterCorporateData = (value: CorporateNumberInfo) => {
  registerCorporateData = value;
};

export const CorporateNumberSearchUI = (props: any) => {
  const { corporateData, setCorporateData } = props;

  // 法人番号
  const [corporateNumberErrorMsg, setCorporateNumberErrorMsg] = useState("");
  setRegisterCheckCorporateNumber(corporateData.corporateNumber);
  setRegisterCheckCorporateNumberErrorMsg(setCorporateNumberErrorMsg);

  // 事業者名
  const [companyNameErrorMsg, setCompanyNameErrorMsg] = useState("");
  setRegisterCheckCompanyName(corporateData.companyName);
  setRegisterCheckCompanyNameErrorMsg(setCompanyNameErrorMsg);

  // 事業者名カナ
  const [companyNameKanaErrorMsg, setCompanyNameKanaErrorMsg] = useState("");
  setRegisterCheckCompanyNameKana(corporateData.companyNameKana);
  setRegisterCheckCompanyNameKanaErrorMsg(setCompanyNameKanaErrorMsg);

  // 法人番号情報
  setRegisterCorporateData(corporateData);

  return (
    <SpaceBetween direction="vertical" size="l">
      <form onSubmit={(e) => e.preventDefault()}>
        <SpaceBetween direction="vertical" size="l">
          <Form>
            <SpaceBetween direction="vertical" size="l">
              <Container
                header={
                  <ColumnLayout columns={2}>
                    <Box float="left">
                      <Header variant="h2">{LABELS.TITLE}</Header>
                    </Box>
                    {props.hasCreatedBy && (
                      <Box float="right">
                        <Badge color="green">
                          {LABELS.LAST_UPDATER}
                          {props.hasCreatedBy}/{LABELS.LAST_UPDATING_TIME}
                          {formatYearDate(props.hasCreatedAt)}
                        </Badge>
                      </Box>
                    )}
                  </ColumnLayout>
                }
              >
                <SpaceBetween direction="vertical" size="l">
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.CORP_NUMBER}</Box>
                        <Box variant="small" color="text-status-error">
                          {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                        </Box>
                      </SpaceBetween>
                    }
                    stretch={true}
                    errorText={corporateNumberErrorMsg}
                    constraintText="半角数字13桁以内"
                  >
                    <ColumnLayout columns={5}>
                      <Input
                        value={corporateData.corporateNumber}
                        onChange={(event) => {
                          setCorporateData({
                            ...corporateData,
                            corporateNumber: event.detail.value,
                          });
                          // コールバックチェック関数
                          checkCorporateNumber(
                            event.detail.value,
                            setCorporateNumberErrorMsg
                          );
                          props.setIsFormEntered(true);
                        }}
                        readOnly={!props.isUpdatable}
                      />
                      <Button
                        formAction="none"
                        variant="normal"
                        onClick={props.onClickCorporateNumberSearch}
                        disabled={!props.isUpdatable}
                      >
                        {LABELS.SEARCH}
                      </Button>
                    </ColumnLayout>
                  </FormField>
                  {props.showCompanyCode && (
                    <ColumnLayout columns={4}>
                      <FormField
                        label={LABELS.CORP_COMPANY_CODE}
                        stretch={true}
                      >
                        <Input
                          value={props.showCompanyCode}
                          onChange={() => {}}
                          readOnly
                        />
                      </FormField>
                    </ColumnLayout>
                  )}
                  <ColumnLayout columns={4}>
                    <FormField
                      label={
                        <SpaceBetween direction="horizontal" size="xs">
                          <Box variant="strong">{LABELS.CORP_NAME}</Box>
                          <Box variant="small" color="text-status-error">
                            {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                          </Box>
                        </SpaceBetween>
                      }
                      stretch={true}
                      errorText={companyNameErrorMsg}
                      constraintText="30文字以内"
                    >
                      <Input
                        value={corporateData.companyName}
                        placeholder={PLACE_HOLDERS.CORP_NAME}
                        onChange={(event) => {
                          setCorporateData({
                            ...corporateData,
                            companyName: event.detail.value,
                          });
                          // コールバックチェック関数
                          checkCompanyName(
                            event.detail.value,
                            setCompanyNameErrorMsg
                          );
                          props.setIsFormEntered(true);
                        }}
                        disabled={!props.isInputEditable}
                        readOnly={!props.isUpdatable}
                      />
                    </FormField>
                    <FormField
                      label={
                        <SpaceBetween direction="horizontal" size="xs">
                          <Box variant="strong">{LABELS.CORP_KANA}</Box>
                          <Box variant="small" color="text-status-error">
                            {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                          </Box>
                        </SpaceBetween>
                      }
                      stretch={true}
                      errorText={companyNameKanaErrorMsg}
                      constraintText="全角カナ45文字以内"
                    >
                      <Input
                        value={corporateData.companyNameKana}
                        placeholder={PLACE_HOLDERS.CORP_KANA}
                        onChange={(event) => {
                          setCorporateData({
                            ...corporateData,
                            companyNameKana: event.detail.value,
                          });
                          // コールバックチェック関数
                          checkCompanyNameKana(
                            event.detail.value,
                            setCompanyNameKanaErrorMsg
                          );
                          props.setIsFormEntered(true);
                        }}
                        disabled={!props.isInputEditable}
                        readOnly={!props.isUpdatable}
                      />
                    </FormField>
                  </ColumnLayout>
                </SpaceBetween>
              </Container>
            </SpaceBetween>
          </Form>
        </SpaceBetween>
      </form>
    </SpaceBetween>
  );
};

export const checkCorporate = () => {
  let checkResult = true;
  if (
    !checkCorporateNumber(
      registerCheckCorporateNumber,
      registerCheckCorporateNumberErrorMsg
    )
  ) {
    checkResult = false;
  }
  if (
    !checkCompanyName(
      registerCheckCompanyName,
      registerCheckCompanyNameErrorMsg
    )
  ) {
    checkResult = false;
  }
  if (
    !checkCompanyNameKana(
      registerCheckCompanyNameKana,
      registerCheckCompanyNameKanaErrorMsg
    )
  ) {
    checkResult = false;
  }
  return checkResult;
};
